/**
 * components/riskTerminal/ordersNote.js
 *
 * The note on every disabled order control — the account's `can_trade` decides what it says
 * (accounts.ordersNote): "Kite is read-only" on a Kite account, the Upstox note otherwise. One context,
 * so the Watchlist's B / S buttons and the order icons read the same thing (upstox-074 found the
 * Watchlist's B / S still saying "use the Upstox app" on a Kite account).
 */
import { createContext } from 'react';
import { NO_ORDERS } from './theme';

export const OrdersNoteCtx = createContext(NO_ORDERS);
